import React from 'react';

import { getDefault } from 'modules/shared-cms/utils';
import { getNestedReferenceId, Actualite, TitleBlocContainer, MentionContainer } from 'modules/shared-cms-advanced';

import enhancer from './appointment-enhancer';

import { AppointmentProps } from './appointment-type';

import styles from './appointment-page.module.css';

const innerPage: React.FC<AppointmentProps> = React.memo(
    ({ titleBlocPicture, actualite, ...rest }: AppointmentProps) => {
        const { actualiteId = getDefault(getNestedReferenceId(actualite), '') } = {};

        return (
            <React.Fragment>
                <div className={styles.rootContainer}>
                    {titleBlocPicture && <TitleBlocContainer titleBlocPicture={titleBlocPicture} {...rest} />}

                    {actualiteId && <Actualite id={actualiteId} />}

                    <div className={styles.gdprBloc}>
                        <MentionContainer {...rest} />
                    </div>
                </div>
            </React.Fragment>
        );
    },
);

export const AppointmentPage = enhancer(innerPage);
